import React, { Fragment } from 'react';
import { useRouter } from 'next/router';

import Text from '../../../designSystem/Text';
import Card from '../../../designSystem/Card';

import styles from './HelpDeskCategoryCard.module.scss';

import routes from '../../../utils/routes';
import componentsId from '../../../utils/componentsId';
import { HELP_DESK_ICONS } from '../../../utils/assets';

type HelpDeskCategoryCardT = {
  category: HelpDeskCategory;
};

const HelpDeskCategoryCard = ({ category }: HelpDeskCategoryCardT) => {
  const router = useRouter();

  const onClickCategoryHandler = () =>
    router.push(`${routes.helpDesk}/${category.categoryKeyword}`);

  return (
    <Card
      id={componentsId.helpDesk.home.categoryCard(category.categoryKeyword)}
      bordered
      selectable
      customClass={styles.help_desk_category_card}
      onClick={onClickCategoryHandler}
    >
      <Fragment>
        <img
          src={HELP_DESK_ICONS(category.icon)}
          alt="bicevida centro de ayuda"
          className={styles.help_desk_category_card_img}
        />
        <Text
          text={category.categoryDescription}
          customClass={styles.help_desk_category_card_title}
        />
      </Fragment>
    </Card>
  );
};

export default HelpDeskCategoryCard;
